import type { Messages } from './en';

export const it: Messages = {
  nav: {
    soon: 'In arrivo',
  },
  hero: {
    eyebrow: 'Per chi gareggia e viaggia',
    headlineLine1: 'Tu pensa alla gara.',
    headlineLine2: 'Al piano pensiamo noi.',
    lead: 'La gara dura tre ore. Il weekend che le sta intorno — gli hotel giusti, i trasferimenti, i pasti, il volo di ritorno — sono tre settimane di schede aperte. La parte difficile l’hai già fatta; al resto pensiamo noi.',
    ctaNote: 'Gratis · senza carta',
  },
  mock: {
    from: 'Da',
    sortCost: 'Costo totale',
    sortDate: 'Data',
    bestValue: 'Miglior rapporto',
    allIn: 'tutto incluso',
  },
  problem: {
    eyebrow: 'Il weekend, non la gara',
    heading: 'La gara non è mai dove dice il nome.',
    body1:
      'Prima calcoli se puoi anche solo permettertela — l’iscrizione è la parte facile; sono i voli, gli hotel e tutto il resto a decidere se il viaggio si fa davvero. Mettiamo di sì.',
    body2:
      'E poi scopri che la sede è a un’ora dalla città. Quindi un hotel vicino alla partenza, un altro in centro per recuperare, treni che non hai mai preso, cene da trovare due volte e un volo di ritorno da calcolare a ritroso. Niente di tutto questo è la gara — e ricade tutto su di te.',
    realCost: 'Costo reale?',
    returnLeg: 'Ritorno',
    crewMessage: '«dove dormiamo??»',
    yourWeekend: 'Il tuo weekend',
    sorted: 'Risolto',
    flights: 'Voli',
    stay: 'Soggiorno · 2 notti',
    race: 'Gara · Beast',
    allIn: 'Totale',
  },
  discovery: {
    eyebrow: 'Cosa fa',
    heading: 'Calcoliamo l’intero viaggio, prima che ti impegni.',
    lead: 'Dicci da dove parti. RaceAtlas ordina ogni gara in base a quanto ti costerà davvero — da porta a porta — iscrizione, volo o auto, e un posto dove dormire. Fasce oneste, una valutazione di affidabilità su ogni cifra e la gara più conveniente che vale la pena, in cima.',
    feat1Kicker: 'Numeri onesti',
    feat1Heading: 'Una valutazione di affidabilità su ogni costo',
    feat1Body:
      'Iscrizione, viaggio, soggiorno — ogni voce indica quanti dati reali la supportano. Mai falsa precisione.',
    feat2Kicker: 'Dalla tua porta',
    feat2Heading: 'Auto o aereo, deciso per te',
    feat2Body:
      'Calcoliamo se ti conviene andare in auto o in aereo da casa — e ordiniamo il costo totale di conseguenza.',
    feat3Kicker: 'Prima ciò che vale',
    feat3Heading: 'Ordinate, non solo elencate',
    feat3Body:
      'La gara più conveniente che vorresti davvero è in cima. Riordina per data o distanza con un tocco.',
  },
  twoJobs: {
    eyebrow: 'Gratis vs a pagamento',
    heading: 'Gratis ti dice quanto costa. Con 9,99 € ti dice cosa fare.',
    freeTag: 'Gratis · uno strumento',
    freeHeading: 'Sapere quanto costa',
    freeBody:
      'Cerca, ordina e confronta ogni gara per costo totale reale da casa. Salva la tua lista. Illimitato, per sempre.',
    paidTag: '9,99 € · un servizio',
    paidHeading: 'Sapere cosa fare',
    paidBody:
      'Un piano per il weekend che decide al posto tuo — orari della mattina di gara, parcheggio e deposito sacche, e caffè e cena già scelti, sul tuo percorso e secondo la tua dieta.',
  },
  payoff: {
    eyebrow: 'L’itinerario da 9,99 €',
    heading: 'Come un amico che la gara l’ha già fatta.',
    body1:
      'Un amico non ti dà una lista di otto bar — ti dice dove andare. Noi pure: il caffè sulla strada verso la partenza, la cena post-gara adatta alla tua dieta, il minuto esatto per uscire e non perdere il deposito sacche. Già scelto, con il motivo in vista. Cambia tutto con un tocco.',
    body2:
      'Conosce il percorso, gli orari delle batterie, il parcheggio, il tragitto. Le cose che impareresti solo a tue spese — la seconda volta.',
    cardDay: 'Sab 23 ago · giorno di gara',
    leaveHotel: 'Lascia l’hotel',
    leaveHotelSub: '15 min · il parcheggio apre alle 07:00',
    coffee: 'Caffè · Bar Nuovo',
    coffeeSub: 'sul tuo percorso · +6 min · apre alle 06:30',
    raceStart: 'Partenza · Beast',
    postRace: 'Pasto post-gara · Sa Tanca',
    postRaceSub: 'vegetariano · +3 min al ritorno',
  },
  who: {
    eyebrow: 'Per chi è',
    heading: 'Pensato per chi gareggia e viaggia per farlo.',
    lead: 'Atleti di endurance agonisti con 5-15 eventi all’anno — Spartan più Hyrox più una tappa UTMB più una Tough Mudder è un calendario normale. Se gareggi una volta all’anno, il piano gratuito ti basta e avanza. Se stai pianificando più weekend all’estero e vuoi che sembri meno un lavoro — siamo noi.',
  },
  pricing: {
    eyebrow: 'Prezzi',
    heading: 'Gratis per decidere. Paghi per la parte che non trovi da nessun’altra parte.',
    freeTier: 'Gratis',
    freeAmount: '0 €',
    freeCadence: 'per sempre',
    freeDesc: 'Ordina ogni gara per costo reale, dalla tua porta. Salva una lista.',
    freeItem1: 'Ricerca e ordinamento costi illimitati',
    freeItem2: 'Fino a 3 piani salvati',
    freeItem3: 'Calendario + promemoria',
    perTripTier: 'Per viaggio',
    perTripBadge: 'Il prodotto',
    perTripAmount: '9,99 €',
    perTripCadence: 'pagamento unico per gara',
    perTripDesc: 'Il weekend di gara, pianificato e deciso — come un amico che l’ha già fatto.',
    perTripItem1: 'Programma della mattina di gara + parcheggio',
    perTripItem2: 'Caffè, pasti e recupero, già scelti',
    perTripItem3: 'Condivisibile · rimborsabile per 7 giorni',
    seasonTier: 'Pass stagionale',
    seasonBadge: 'Presto',
    seasonAmount: '45 €',
    seasonCadence: 'all’anno',
    seasonDesc: 'Per 8+ gare all’anno. L’intera stagione, illimitata, in un solo posto.',
    seasonItem1: 'Tutti gli itinerari inclusi',
    seasonItem2: 'Spesa di stagione, budget e sovrapposizioni',
    seasonItem3: 'Tempistica di prenotazione (dopo il lancio)',
  },
  final: {
    heading: 'Tu pensa alla gara.',
    lead: 'Al resto pensiamo noi — quanto costa, dove dormi, come ci arrivi, cosa fare appena atterri. Gratis per iniziare, senza carta.',
  },
  footer: {
    privacy: 'Privacy',
    terms: 'Termini',
    contact: 'Contatti',
  },
  seo: {
    title: 'Race Atlas — Tu pensa alla gara, al piano pensiamo noi',
    description:
      'Race Atlas pianifica i tuoi weekend di gara dall’inizio alla fine — quanto costano davvero, dove dormire, come arrivare e cosa fare appena atterri. Tu pensa alla gara; al piano pensiamo noi.',
  },
};
